import React, { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import Accordion from "../../../common/accordion";
import useInputValidations from "../InputValidations";
import useJetliftCollapseFacade from "../../../../facade/jetlift/collapse/collapse.facade";
import { LABELS } from "../../../../constants/labels/jetlift/jetlift.labels";
import TextInput from "../../../common/Jetlift/TextInput";

const JetPump: React.FC = () => {
    const [form, setForm] = useState<{ [key: string]: string }>({});
    const { register, control } = useFormContext();
    const { sectionsData, renderField } = useInputValidations();
    const { getdefaultCollapse, handleCollapseChange } = useJetliftCollapseFacade();

    const handleChange = (label: string, value: string) => {
        setForm((prev) => ({ ...prev, [label]: value }));
    };

    return (
        <div className="flex flex-col gap-[16px]">
            {sectionsData?.jetPump?.map((section, secIdx) => {
                return (
                    <div
                        key={secIdx}
                        className="flex flex-col"
                    >
                        {section?.section !== "" ?
                            <Accordion
                                title={section.section}
                                isOpen={getdefaultCollapse(section?.section) ?? false}
                                onToggle={() => { handleCollapseChange(!getdefaultCollapse(section?.section), section?.section) }}
                                content={
                                    <div className="flex flex-col gap-[16px] p-[12px]">
                                        {section.fields.map((field, idx) => (
                                            <div key={idx}>
                                                {renderField(field, form, handleChange, register, control)}
                                            </div>
                                        ))}
                                    </div>
                                }
                            />
                            :
                            (
                                <>
                                    {section?.fields.map((field, idx) => (
                                        <div key={idx}>
                                            {renderField(field, form, handleChange, register, control)}
                                        </div>
                                    ))}
                                </>
                            )}
                    </div>
                )
            })}
            <Accordion
                title={LABELS?.powerFluidType}
                isOpen={getdefaultCollapse(LABELS?.powerFluidType) ?? false}
                onToggle={() => { handleCollapseChange(!getdefaultCollapse(LABELS?.powerFluidType), LABELS?.powerFluidType) }}
                content={(
                    <div className="flex flex-col gap-[8px] p-3 w-full overflow-x-hidden">
                        {sectionsData?.jetPumpRange?.map((section) => {
                            const field1 = section?.field1?.[0];
                            return renderField(field1, form, handleChange, register, control);
                        })}
                        <label>{LABELS?.powerFluidPressureRange}</label>
                        <div className="grid grid-cols-3 gap-4 w-full min-w-0">
                            {sectionsData?.jetPumpRange?.map((section) => {
                                const field = section?.field2;
                                return field?.map((field: any, id: number) => {
                                    const fieldName = field?.name || field?.label;
                                    return (
                                        <div key={id} className="min-w-0">
                                            <Controller
                                                name={fieldName}
                                                control={control || {}}
                                                rules={field?.rules}
                                                render={({ field: formField, fieldState: { error } }) => (
                                                    <TextInput
                                                        name={fieldName}
                                                        label={field?.label}
                                                        type={field?.type === 'number' ? 'number' : 'text'}
                                                        placeholder={field?.placeholder}
                                                        unit={field?.unit}
                                                        error={error?.message}
                                                        control={control}
                                                        rules={field?.rules}
                                                        required={field?.required}
                                                        onChange={field?.onChange}
                                                        onBlur={field?.onBlur}
                                                        value={field?.value}
                                                        disabled={field?.disabled}
                                                        className={field?.className || "w-full"}
                                                    />
                                                )}
                                            />
                                        </div>
                                    )
                                })
                            })}
                        </div>
                        {sectionsData?.jetPumpRange?.map((section) => {
                            const field3 = section?.field3?.[0];
                            return renderField(field3, form, handleChange, register, control);
                        })}
                        {sectionsData?.jetPumpRange?.map((section, idx) => {
                            const field = section?.field4?.[0];
                            return (
                                <>
                                    {field?.enabled ?
                                        (<div className="flex justify-between text-neutral-25">
                                            <label>{field?.label}</label>
                                            <label>{field?.value} {field?.unit}</label>
                                        </div>) : null}
                                </>
                            )
                        })}
                    </div>
                )}
            />
            {sectionsData?.jetPumpGasVent?.map((field, id) => {
                return (
                    <div className="flex flex-col gap-[16px]" key={id}>
                        {field?.fields.map((field, idx) => (
                            <div key={idx}>
                                {renderField(field, form, handleChange, register, control)}
                            </div>
                        ))}
                    </div>
                )
            })}
        </div>
    );
};

export default JetPump;